export default "__VITE_ASSET__DSsR1p81__"